import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center">
                <i className="ri-smartphone-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: "Pacifico, serif" }}>Device Doctor</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Kerala's trusted mobile and laptop repair center with 10+ years of experience. 
              Expert technicians, genuine parts, and reliable service.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/people/Device-Doctor" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a 
                href="https://instagram.com/device_doctor_" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a 
                href="https://youtube.com/@mobilerepairkerala" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">All Services</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><a href="/privacy-policy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="/terms-conditions" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Terms & Conditions</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Brand Services</h3>
            <ul className="space-y-3">
              <li><a href="/samsung-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Samsung Repair</a></li>
              <li><a href="/apple-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Apple Repair</a></li>
              <li><a href="/google-pixel-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Google Pixel Repair</a></li>
              <li><a href="/oneplus-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">OnePlus Repair</a></li>
              <li><a href="/vivo-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Vivo Repair</a></li>
              <li><a href="/realme-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Realme Repair</a></li>
              <li><a href="/motorola-service" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Motorola Repair</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-red-400 mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm">Store no 1, Near Nakshatra Jewellery</p>
                  <p className="text-gray-400 text-sm">Vyttila Jn, Kochi 682019</p>
                  <p className="text-gray-400 text-sm">Kerala, India</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-red-400"></i>
                <a href="tel:+918714014140" className="text-gray-400 hover:text-white transition-colors cursor-pointer">+91 8714014140</a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-whatsapp-line text-red-400"></i>
                <a href="https://wa.me/918714014140" className="text-gray-400 hover:text-white transition-colors cursor-pointer">WhatsApp Us</a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-line text-red-400"></i>
                <div>
                  <p className="text-gray-400 text-sm">Mon-Sat: 10AM-7PM</p>
                  <p className="text-gray-400 text-sm">Sun: 11AM-4PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <p className="text-center text-gray-400 text-sm">
            © 2024 Device Doctor. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};